/* global Routes */
// @flow
import React from 'react'
import DashboardHeaderTop from '../../../components/project_dashboard/Header/DashboardHeaderTop'

type Props = {
  model: Object,
  currentAccount?: Object,
}

export default class DashboardHeaderTopContainer extends React.Component<Props> {
  getDashboardPath () {
    const accountSlug = this.props.model.get('account_slug')
    return accountSlug
      ? Routes.account_projects_path(accountSlug)
      : 'https://codebeat.co/'
  }

  render () {
    const props = {
      model: this.props.model,
      title: this.props.model.get('full_name'),
      gpa: this.props.model.get('gpa'),
      private: this.props.model.get('private'),
      favourite: this.props.model.get('favourite'),
      default_branch_name: this.props.model.get('default_branch_name'),
      last_analysed_commit_hash: this.props.model.get('last_analysed_commit_hash') && this.props.model.get('last_analysed_commit_hash').substr(0, 8),
      last_analysed_commit_url: this.props.model.get('last_analysed_commit_url'),
      currentAccount: this.props.currentAccount,
      dashboardPath: this.getDashboardPath()
    }

    return <DashboardHeaderTop {...props} />
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/containers/project_dashboard/Header/DashboardHeaderTopContainer.js